export const GET_REQUESTS = 'GET_REQUESTS';
export const NO_REQUESTS = 'NO_REQUESTS';
export const DELETE_REQUEST = 'DELETE_REQUEST';
export const CREATE_REQUEST = 'CREATE_REQUEST';
export const CHANGE_REQUEST_STATUS = 'CHANGE_REQUEST_STATUS';
export const SHOW_CONFIRMATION_MODAL = 'SHOW_CONFIRMATION_MODAL';
export const CLOSE_CONFIRMATION_MODAL = 'CLOSE_CONFIRMATION_MODAL';
export const REQUEST_ERROR = 'REQUEST_ERROR';
export const HANDLE_ERROR = 'HANDLE_ERROR';